<template>
  <div class="content">
    <div class="content-top">
      <div @click="selectIndex(0)">
        <div>
          <p class="number">{{num.allCount}}</p>
          <p class="title">累计检查数量</p>
        </div>
        <div>
          <img style="width: 6vw" src="../../../assets/image/safe/count.png">
        </div>
      </div>
       <div @click="selectIndex(1)">
        <div>
          <p class="number">{{num.monthCount}}</p>
          <p class="title">本月检查</p>
        </div>
        <div>
          <img style="width: 6vw" src="../../../assets/image/safe/month.png">
        </div>
      </div>
      <div @click="selectIndex(2)">
        <div>
          <p class="number">{{num.weekCount}}</p>
          <p class="title">本周检查</p>
        </div>
        <div>
          <img style="width: 6vw" src="../../../assets/image/safe/week.png">
        </div>
      </div>
       <div @click="selectIndex(3)">
        <div>
          <p class="number">{{num.disposeCount}}</p>
          <p class="title">已处理</p>
        </div>
        <div>
          <img style="width: 6vw" src="../../../assets/image/safe/yes.png">
        </div>
      </div>
       <div @click="selectIndex(4)">
        <div>
          <p class="number">{{num.unDisposeCount}}</p>
          <p class="title">未处理</p>
        </div>
        <div>
          <img style="width: 6vw" src="../../../assets/image/safe/no.png">
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="content-box-1">
        <div class="button" style="margin-right: 1vw" @click="addConfig">预警设置</div>
        <div class="button" @click="toAdd">添加巡查</div>
      </div>
      <div class="content-box-2">
        <div class="item" v-for="(item,index) in proQsList" :key="index">
          <div style="height: 170px;width: 170px">
            <img :src="item.pic" style="width:100%;height:100%;" />
          </div>
          <div style="width: 74%">
            <el-row style="margin-top: 10px">
              <el-col :span="6" class="left nowrap">
                <span class="color1" style="color: #666666;fontSize:14px">{{item.type==1?'日常巡查':item.checkType==1?'质量巡查':'安全巡查'}}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 15px">
              <el-col :span="6" class="left nowrap">
                <span class="color1">计划名称：</span><span class="color2">{{item.planDescription||'--'}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">检查结果：</span><span class="color2">
                  <span v-if="item.checkResult=='无'" style="color:#1ed76d;">{{'合格'||'--'}}</span>
                  <span v-else-if="item.checkStatus=='已处理'" style="color:#E6A23C">{{item.checkResult}}</span>
                  <span v-else style="color:red;">{{'待整改'||'--'}}</span>
                </span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">处理状态：</span><span class="color2">{{item.checkStatus ||'--'}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">确认状态：</span><span class="color2">{{item.affirmStatus || '--'}}</span>
              </el-col>
            </el-row >
              <el-row style="margin: 22px 0;">
              <el-col :span="6" class="left nowrap">
                <span class="color1">检查内容：</span><span class="color2">{{item.description}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">检查人：</span><span class="color2">{{item.reportName}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">责任人：</span><span class="color2">{{item.handlerName ||'--'}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">确认人：</span><span class="color2">{{item.affirm || '--'}}</span>
              </el-col>
            </el-row>
              <el-row>
                <el-col :span="6" class="left">
                <span class="color1">隐患级别：</span><span class="color2">{{item.priorityName||'无'}}</span>
              </el-col>
                <el-col :span="6" class="left">
                <span class="color1">检查时间：</span><span class="color2">{{item.happenDate}}</span>
              </el-col>
              <el-col :span="6" class="left nowrap">
                  <span class="color1">地址：</span><span class="color2">{{item.address || '--'}}</span>
                </el-col>
                <el-col :span="6" class="left nowrap">
                  <span class="color1">发起角色：</span><span class="color2" :title="item.addressUser">{{item.addressUser || '--'}}</span>
                </el-col>
            </el-row>
          </div>
          <div style="display: flex;flex-direction: column;justify-content: center;">
            <div class="button" style="margin-bottom: 10px" @click="toDetail(item)">详情</div>
            <div class="button" @click="toDownFile(item)">导出</div>
          </div>
        </div>
      </div>
      <div class="content-box-3">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 预警设置弹出框 -->
     <el-dialog width="500px" title="预警配置" :visible.sync="warnVis" append-to-body center>
      <div slot="title" class="dialog-title">预警配置</div>
        <el-form
        :model="set"
        ref="set"
        label-width="160px"
        label-position="right"
        >
            <el-form-item v-for="(item,index) in setList" :key="index" :label="item.priorityName+'：'">
                <el-select v-model="item.limitDate" placeholder="请选择时间">
                <el-option
                    v-for="item in dateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="warnVis = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="configInfo()" style="background-color: #4D6EB1;">确 定</el-button>
        </div>
    </el-dialog>

    <!-- 添加巡查弹出框 -->
    <el-dialog
      class="dialog"
      :visible.sync="dialog"
      width="500px"
      center
      >
      <div slot="title" class="dialog-title">添加巡查</div>
      <el-form
        label-width="120px"
        label-position="right"
        >
        <el-form-item label="检查内容：">
          <el-input v-model="description" type="textarea" placeholder="请输入内容" :autosize="{ minRows: 4}"></el-input>
        </el-form-item>
        <el-form-item label="添加图片：">
          <el-upload style="display: flex;padding: 20px 0;" :action="uploadphotoUrl" list-type="picture-card"
            :headers="uploadHead" :data="uploadphotoData"
            :on-success="handleIconSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="检查类型：">
          <el-select v-model="checkType" size="medium">
            <el-option label="质量检查" :value="1"></el-option>
            <el-option label="安全检查" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <div class="duoxuan">
          <el-radio v-model="type" label="1" style="margin-right:4vw">日常巡查</el-radio>
          <el-radio v-model="type" label="2">安全/质量检查</el-radio>
        </div>
        <div v-if="type=='2'">
        <el-form-item label="巡查计划：">
          <div class="xuanxiang">
            <div class="rowAA" v-for="(item,index) in proQsPlans">
              <span style="font-size:16px">{{item.napeId}}</span><br>
              <el-radio @change="xuanze" style="margin-left:15px" v-model="qsItemId" :label="item.id"><span class="textA">{{item.safeItem}}</span></el-radio>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="责任人：">
          <el-select v-model="handleStr" size="medium">
            <el-option v-for="item in strPerson" :key="item.userId" :label="item.personName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="确认人：">
          <el-select v-model="apprStr" size="medium">
            <el-option v-for="item in strPerson" :key="item.userId" :label="item.personName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="BIM位置：">
          <el-select v-model="bimId" size="medium">
            <el-option v-for="item in bimHouse" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialog = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitFun" style="background-color: #4D6EB1;">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 20,
        total: 0,        
        projectId: '',
        groupId: '',
        warnVis: false,    // 预警弹出框
        dialog: false,     // 添加巡查弹出框
        setList: [],
        set:{
          projectId:'',
          priorityTyep:'',
          limitDate:'',
        },
        dateList:[
          {id:'0',name:'12小时',value:'12'},
          {id:'1',name:'24小时',value:'24'},
          {id:'2',name:'48小时',value:'48'},
          {id:'3',name:'72小时',value:'72'},
        ],
        num:{
          allCount: 0,
          disposeCount: 0,
          monthCount: 0,
          unDisposeCount: 0,
          weekCount: 0,
        },
        proQsList: [],
        head1:{
          timeType:3,//时间类型  1：日    2：周    3：月
          time1:util.myTime.getCurTime(),
          time2:util.myTime.getWeekDay(-1),
          time3:util.myTime.getCurMonth(),
          startDate:'',
          endDate:'',
          flag:'5', 
          type:'',
        },
        curId: 0,
        types: [],
        strPerson: [],
        priority: '',
        handleStr: '',
        apprStr: '',
        bimId: '',
        bimHouse:[
          {id:'1',label:'1栋',value:'1'},{id:'2',label:'2栋',value:'2'},{id:'3',label:'3栋',value:'3'},{id:'4',label:'4栋',value:'4'},
          {id:'5',label:'5栋',value:'5'},{id:'6',label:'6栋',value:'6'},{id:'7',label:'7栋',value:'7'},{id:'8',label:'8栋',value:'8'},
          {id:'9',label:'9栋',value:'9'},{id:'10',label:'10栋',value:'10'},{id:'11',label:'11栋',value:'11'},{id:'12',label:'12栋',value:'12'},
          {id:'13',label:'13栋',value:'13'},
        ],
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        fileList: [],
        description: '',
        proQsPlans:[], // 计划列表
        qsItemId:'',
        type:'2',
        checkType:''
      }
    },
    created() {
      this.groupId = util.session.get('groupId')
      this.projectId = util.session.get('groupId')
      this.getDictByType()
      this.getNum()
      this.getData()
      this.getPerson()
      this.selectProQsPlanList()
    },
    methods: {
      selectProQsPlanList(){
        myHttp.selectProQsPlanList({
          projectId:util.session.get('groupId')
        }).then(res=>{
          if(res.data.code==200){
            console.log(res)
            this.proQsPlans = res.data.data.proQsPlans
          }
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      selectIndex(index){
        console.log(index,this.curId)
        if(this.curId!=index){
            this.curId = index
            if(this.tabIndex==0){
                this.getData()
            }else{
                this.getData()
            }
        }
      },
      //获取项目检查
      getData(){
        var dispose = 3
        var type = ''
        if(this.curId==0){
            this.head1.startDate = '';
            this.head1.endDate = '';
            dispose = 3
        }else if(this.curId==2){
            var obj = util.myTime.getWeekDateWai()
            this.head1.startDate =  obj.start;
            this.head1.endDate = obj.end;
            dispose = 3
        }else if(this.curId==1){
            this.head1.startDate = this.head1.time3+'-01';
            var day = new Date(parseInt(this.head1.time3.split('-')[0]),parseInt(this.head1.time3.split('-')[1]),0).getDate();
            this.head1.endDate = this.head1.time3+'-'+day;
            dispose = 3
        }else if(this.curId==3){
            this.head1.startDate = '';
            this.head1.endDate = '';
            dispose = 2
            type = 2
        }else if(this.curId==4){
            this.head1.startDate = '';
            this.head1.endDate = '';
            dispose = 1
            type = 2
        }
        var that = this
        myHttp.selectQsListByProjectIdPageNew({
            projectId:this.projectId,
            starTime:this.head1.startDate,
            endTime:this.head1.endDate,
            form:'1',
            type:type,
            dispose:dispose,
            pageNum:this.pageNum,
            pageSize:this.pageSize
        }).then(function(resp) {
            console.log(resp,'10086')
            if(resp.data.code=='200'){
                var list = resp.data.data.qsList.list||[]
                for(var i=0;i<list.length;i++){
                  for(var j=0;j<that.types.length;j++){
                      if(list[i].priority==that.types[j].value){
                        list[i].priorityName =that.types[j].label
                      }
                    }
                    list[i].pic = list[i].picUrls && list[i].picUrls!=''?base.httpCtx+(list[i].picUrls.split(',')[0]):require('../../../assets/image/project.png')
                    list[i].affirmpic = list[i].affirmPicUrls && list[i].affirmPicUrls!=''?base.httpCtx+(list[i].affirmPicUrls.split(',')[0]):require('../../../assets/image/zanwutupian.png')
                  }
                that.total = resp.data.data.qsList.total||0
                that.proQsList = list
            }
        })
      },
      xuanze(itemA){
        this.proQsPlans.forEach((item,index)=>{
          if(item.id==itemA){
            this.description = item.safeItem
          }
        })
      },
       // 获取问题列表
      getDictByType(){
        var that = this
        myHttp
            .getDictByType({
            type: 'qs_priority'
            })
            .then(function(resp) {
            if (resp.data.code == '200') {
                that.types = resp.data.data.dictList
                var list = resp.data.data.dictList
                that.setList = []
                for(var i=0;i<list.length;i++){
                    var obj = {
                        projectId:that.groupId,
                        priorityTyep:list[i].value,
                        priorityName:list[i].label,
                        limitDate:'',
                    }
                    that.setList.push(obj)
                }
            } else {
                that.$message.error(resp.data.msg)
            }
        })
      },
      //展示配置弹出框
      addConfig(){
        this.warnVis = true
        var that = this
        myHttp.selectQsConfigurationByProjectId({
            projectId:this.groupId
        }).then(function(resp){
          console.log(resp);
            if(resp.data.code=='200'){
                var list = resp.data.data||[]
                if(list.length>0){
                    for(var i=0;i<list.length;i++){
                        that.setConfig(list[i])
                    }
                }else{
                    for(var i=0;i<that.setList;i++){
                          that.setList[i].limitDate = ''
                    }
                }
                
            }
        })
      },
      //插入数据
      setConfig(obj){
        for(var i=0;i<this.setList.length;i++){
            if(obj.priorityTyep==this.setList[i].priorityTyep){
                this.setList[i].limitDate = obj.limitDate
            }
        }
        console.log(this.setList)
      },
      //提交
        configInfo(){
            var that = this
            myHttp.addQsConfiguration({
                jsonString:JSON.stringify(this.setList)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('操作成功')
                    that.warnVis = false
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
        //获取数量
        getNum(){
            var that = this
            var form = '1'
            myHttp.selectQsCountByProjectId({
                projectId:this.projectId,
                form:form
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    if(data){
                        that.num = data
                    }
                }
            })
        },
        toDetail(row){
          // handle:是否从我的里面进去
          this.$router.push({ name: 'qsDetail', params: { id: row.qsId ,type:row.type,handle:'1'} })
        },
        toDownFile(row){
          var token = util.session.get('token')
          window.open(
              myHttp.exportQsInfo +
              '?id=' +
              row.qsId +
              '&accessToken=' +
              token
          )
      },
      // 获取责任人列表
      getPerson() {
        var that = this;
        myHttp
          .findProjectUserPage({
            projectId: util.session.get('groupId'),
            pageNum:1,
            pageSize:1000
          })
          .then(function (resp) {
            console.log(resp);
            if (resp.data.code == '200') {
              that.strPerson = resp.data.data.projectUserPage.list
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          console.log(opt)
          console.log(res)
          this.fileList = opt
        } else {
          this.$message.error(res.msg)
        }
      },
      submitFun() {
        var that = this
        var picUrls = []
        var that = this
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].response.data.saveUrls)
        }
        // console.log(picUrls.toString())
        this.picUrls = picUrls.toString()
        let form = null
        if(this.type=='1'){
          form={
            form:'1',
          projectId: this.groupId,
          type: this.type,
          // priority: this.priority, //问题性质
          // happenDate: this.data.date, //发生时间
          description: this.description, //问题描述
          picUrls: this.picUrls, //问题图片
          handleStr: '', //责任人id
          // apprStr: this.apprStr, //确认人id
          reportBy: util.session.get("user").id, //发起人
          // qsItemId: this.qsItemId,
          // planId: this.planId,
          // bimId:this.bimId,
          checkType: this.checkType
          }
          myHttp
          .createInfoQs(form)
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.getData()
              that.getNum()
              that.dialog = false
              that.type = ''
              // that.priority = ''
              that.handleStr = ''
              that.apprStr = ''
              that.bimId = ''
              that.description = ''
              that.fileList = []
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }else if(this.type=='2'){
          form = {
            form:'1',
            projectId: this.groupId,
            type: this.type,
            // priority: this.priority, //问题性质
            // happenDate: this.data.date, //发生时间
            description: this.description, //问题描述
            picUrls: this.picUrls, //问题图片
            handleStr: this.handleStr, //责任人id
            apprStr: this.apprStr, //确认人id
            reportBy: util.session.get("user").id, //发起人
            qsItemId: this.qsItemId,
            // planId: this.planId,
            bimId:this.bimId,
            checkType: this.checkType
          }
          if(this.qsItemId==''){
            this.$message({
              type:'error',
              message:'请选择巡查计划'
            })
            return
          }
          myHttp
          .createInfoNewQs(form)
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.getData()
              that.getNum()
              that.dialog = false
              that.type = ''
              // that.priority = ''
              that.handleStr = ''
              that.apprStr = ''
              that.bimId = ''
              that.description = ''
              that.fileList = []
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
        // if (!form.picUrls) {
        //   this.$message.error('请上传照片')
        //   return
        // }
        // if (!form.priority) {
        //   this.$message.error('请选择问题性质')
        //   return
        // }
        // if (!form.handleStr) {
        //   this.$message.error('请选择责任人')
        //   return
        // }
        // console.log(form)
      },
      toAdd(){
        let that = this
              // that.priority = ''
              that.handleStr = ''
              that.apprStr = ''
              that.bimId = ''
              that.description = ''
              that.fileList = []
              that.checkType = ''
              that.qsItemId = ''
              this.dialog = true
        // this.$router.push({
        //   path: '/newAddPatrol'
        // })
      }
    },
  }
</script>

<style scoped>
.color1{
  color: #9E9E9E;
  font-size: 14px;
}
.color2{
  color: #666;
  font-size: 14px;
}
.left{
  text-align: left;
}
.content{
  padding: 1vh 1vw;
}
.content-top{
 display: flex;
 justify-content: space-between;
 margin-bottom: 2vh;
}
.content-top >  div{
  display: flex;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  padding: 0 1.5vw;
  width: 19%;
  height: 150px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  cursor: pointer;
}
.number{
  font-size: 2.2vw;
  color: #666;
}
.title{
  font-size: 20px;
  color: #666;
}
.content-box{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-box-1{
  padding: 1vh 1vw;
  text-align: right;
  border-bottom: 2px solid #E7E7E7;
}
.button{
  display: inline-block;
  width: 65px;
  height: 28px;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 28px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.content-box-2{
  padding: 8px;
  height: 59vh;
  overflow: auto;
}
.item{
  display: flex;
  height: 175px;
  justify-content: space-between;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(77, 110, 177, 0.1);
  margin-bottom: 8px;
  padding-right: 1vw;
}
.content-box-3{
  border-radius: 0px 0px 6px 6px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.el-pagination{
  border-radius: 0 0 6px 6px;
}
/deep/ .el-dialog__header{
  padding: 0;
}
.dialog-title{
  padding: 9px 24px;
  height: 40px;
  text-align: left;
  font-size: 16px;
  color: #666666;
  background-color: #ECF0F5;
}
/deep/ .el-dialog__close{
  font-size: 24px;
}
/deep/ .el-dialog__headerbtn{
  top: 10px;
}
.dialog >>> .el-input{
  width: 300px;
}
.content >>> .el-textarea{
  width: 300px!important;
}
.duoxuan{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.xuanxiang{
  border: 1px solid #eee;
  width: 100%;
  height: 25vh;
  overflow: auto;
}
.rowAA{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
.textA{
  overflow: hidden;
  white-space:pre-wrap;
}
</style>